<div class="restart-all-dialog" fxLayout="column" fxLayoutAlign="center center">
  <ng-container *ngIf="status === 'loading'">
    <div class="wheel-and-hamster" role="img" aria-label="Trwa uruchamianie odświeżania sald">
      <div class="wheel"></div>
      <div class="hamster">
        <div class="hamster__body">
          <div class="hamster__head">
            <div class="hamster__ear"></div>
            <div class="hamster__eye"></div>
            <div class="hamster__nose"></div>
          </div>
          <div class="hamster__limb hamster__limb--fr"></div>
          <div class="hamster__limb hamster__limb--fl"></div>
          <div class="hamster__limb hamster__limb--br"></div>
          <div class="hamster__limb hamster__limb--bl"></div>
          <div class="hamster__tail"></div>
        </div>
      </div>
      <div class="spoke"></div>
    </div>

    <h3>Uruchamianie odświeżania sald...</h3>
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </ng-container>

  <ng-container *ngIf="status === 'accepted'">
    <h3>Odświeżanie sald zostało zakończone.</h3>
    <p>Proces odświeżania sald został wykonany pomyślnie.</p>
    <button mat-raised-button color="primary" (click)="close()">
      Zamknij
    </button>
  </ng-container>

  <ng-container *ngIf="status === 'error'">
    <mat-error>{{errorMessage}}</mat-error>
    <button mat-raised-button color="primary" (click)="close()">Zamknij</button>
  </ng-container>
</div>
